<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="addSocial"
                            type="button">
                        <icon name="plus"></icon> เพิ่มเรทประกันสังคม
                    </button>&nbsp;&nbsp;
                    &nbsp;
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                    <tr>
                        <th scope="col">ลำดับ</th>
                        <th scope="col">เรทเงิน</th>
                        <th scope="col">เรทเปอร์เซ็น</th>
                        <th scope="col">จ่ายขั้นต่ำ(วีค1)</th>
                        <th scope="col">วันที่</th>
                        <th scope="col">จัดการข้อมูล</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(data,index) in taxPersonList">
                        <td>{{index+1}}</td>
                        <td>{{data.rate | currency }}</td>
                        <td>{{data.rate_percent }}%</td>
                        <td>{{data.minimum_rate | currency}}</td>
                        <td>{{data.date | moment("DD-MM-YYYY")}}</td>
                        <td>
                            <a @click="showSocialPerson(data.id)">
                                <icon name="pencil-alt"></icon>
                            </a>
                            &nbsp;&nbsp;
                            <a @click="showDeleteModal(data.id)">
                                <icon name="trash"></icon>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- ----Modal Add Social Security---- -->
        <b-modal hide-header hide-footer ref="add_social_security">
        </b-modal>

        <!-- ----Modal delete Social Security---- -->
        <b-modal hide-header hide-footer ref="delete_social_security">
            <div style="text-align: center;">
                <h4>คุณต้องการลบสิ่งนี้ใช่หรือไม่?</h4>
                <br />
                <button @click="deleteSocialSecurity"
                        type="button"
                        class="btn btn-success mt-2">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button
                        type="button"
                        @click="hideDeleteModal"
                        class="btn btn-outline-secondary mt-2">
                    ยกเลิก
                </button>
            </div>
        </b-modal>

        <br>
        <b-modal hide-footer hide-header ref="social">
            <div style="text-align: center;">
                <h4>เพิ่มเรทประกันสังคม</h4>
                <br />
                <b-row sm="10">
                    <b-col sm="4" class="col text-right">
                        <label>เรทเงิน</label>
                    </b-col>
                    <b-col sm="6">
                        <input v-model="form.rate"
                               type="number" class="form-control"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row sm="10">
                    <b-col sm="4" class="col text-right">
                        <label>เรทเปอร์เซ็น</label>
                    </b-col>
                    <b-col sm="6">
                        <input v-model="form.rate_percent"
                               type="number" class="form-control"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row sm="10">
                    <b-col sm="4" class="col text-right">
                        <label>จ่ายขั้นต่ำ(วีค1)</label>
                    </b-col>
                    <b-col sm="6">
                        <input v-model="form.minimum_rate"
                               type="number" class="form-control"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row sm="10">
                    <b-col sm="4" class="col text-right">
                        <label>วันที่</label>
                    </b-col>
                    <b-col sm="6">
                    <date-picker v-model="form.date"
                                 placeholder="วันที่"
                                 :format="changeFormat"
                                 :lang="lang">
                    </date-picker>
                    </b-col>
                </b-row>
                <br/>
                <button type="button"
                        @click="saveSocial"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button type="button"
                        @click="hideSocialModal"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import Multiselect from "vue-multiselect"
    import moment from "moment";
    import DatePicker from 'vue2-datepicker'
    import Loading from "../../../Utility/Loading";

    export default {
        name: "rate-tax-person-table",
        components: {
            Loading,
            Multiselect,
            DatePicker
        },
        created(){
            this.getSocialSecurity();
        },
        data() {
            return {
                msg : '',
                status_loading : 1,
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            };
        },
        computed:{
            ...mapState({
                taxPersonList:state=>{
                    return state.SocialSecurity.taxPersonList;
                },
                dataPaginate:state=>{
                    return state.SocialSecurity.dataPaginate;
                },
                form:state=>{
                    return state.SocialSecurity.form_security;
                },
            }),
        },
        methods:{
            hideSocialModal(){
                this.$refs.social.hide();
            },
            showSocialModal() {
                this.$refs.social.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            showLoadingModal() {
                this.$refs.loading.show();
            },
            hideDeleteModal(){
                this.$refs.delete_social_security.hide();
            },
            showDeleteModal(id) {
                this.form.id = id;
                this.$refs.delete_social_security.show();
            },
            deleteSocialSecurity(){
                this.$store.dispatch("SocialSecurity/deleteSocialSecurity",this.form.id).then(()=>{
                    this.hideDeleteModal();
                    this.$store.dispatch("SocialSecurity/clearFormData");
                    this.getSocialSecurity();
                });
            },
            getSocialSecurity(){
                this.$store.dispatch("SocialSecurity/setSocialSecurity");
            },
            addSocial(){
                this.$store.dispatch("SocialSecurity/clearFormData").then(()=>{
                    this.showSocialModal();
                })
            },
            saveSocial(){
                let id = this.form.id ? this.form.id : '';
                let data = {
                    rate : this.form.rate ? this.form.rate : '',
                    rate_percent : this.form.rate_percent ? this.form.rate_percent : '',
                    minimum_rate : this.form.minimum_rate ? this.form.minimum_rate : '',
                    date : this.form.date ? moment(this.form.date).format("YYYY-MM-DD") : '',
                }
                if(!data.rate){
                    alert('กรุณากรอก เรทเงิน')
                }else if(!data.rate_percent){
                    alert('กรุณากรอก เรทเปอร์เซ็น')
                }else if(!data.date){
                    alert('กรุณากรอก วันที่')
                }else if(!data.minimum_rate){
                    alert('กรุณากรอก จำนวนขั้นต่ำ')
                }else{
                    this.msg = "กรุณารอสักครู่";
                    this.status_loading = 1;
                    this.showLoadingModal();
                    this.$store.dispatch("SocialSecurity/saveSocialSecurity",{id,data}).then(()=>{
                        this.getSocialSecurity();
                        this.hideLoadingModal();
                    }).catch(()=>{
                        this.msg = "บันทึกไม่สำเร็จ";
                        this.status_loading = 3;
                        this.showLoadingModal();
                    })
                    this.hideSocialModal();
                }
            },
            showSocialPerson(id){
                this.form.id = id ? id : '';
                this.$store.dispatch("SocialSecurity/showSocialSecurityByID",id).then(res=>{
                    this.showSocialModal();
                })
            },
        }
    }
</script>

<style scoped>

</style>
